const CharacterList=()=>{
    return(
        <ul>
            <li><h5>Материал:<span>Бязь-ранфорс</span></h5></li>
            <li><h5>Плотность:<span>135 гр/м2</span></h5></li>
            <li><h5>Размер:<span>Полуторный, Двуспальный, Евро, Семейный</span></h5></li>
            <li><h5>Состав ткани: <span>100% хлопок</span></h5></li>
            <li><h5>Страна производитель:<span>Украина</span></h5></li>
        </ul>
    )
}

export default CharacterList;